import stateData from '../../data/sim/tournament_state.json';

const state = stateData;

/** True if the engine should consult live state. False = pure pre-tournament forecast. */
export function isTournamentLive() {
  return state._meta.tournament_started === true;
}

/** Lookup a decided group-stage match by `${letter}:${pairIdx}`. Returns null if not played. */
export function getGroupResult(slotKey) {
  const r = state.results[slotKey];
  if (!r || r.status !== 'completed' || r.stage !== 'group') return null;
  return r;
}

/** Lookup a decided knockout match by match.id (number → string). */
export function getKnockoutResult(matchId) {
  const r = state.results[String(matchId)];
  if (!r || r.status !== 'completed' || r.stage === 'group') return null;
  return r;
}

/** Live suspensions for a team, projected onto the Absence shape so they
 *  feed through the same criticality / penalty pipeline as injuries. */
export function liveSuspensions(teamId) {
  return (state.live_suspensions || [])
    .filter((s) => s.team === teamId)
    .map((s) => ({
      player: s.player,
      position: s.position,
      minutes_qual: 0,
      market_value_mil: s.market_value_mil,
      reason: s.reason,
      applies_from_stage: s.from_stage,
    }));
}

/** All decided results, keyed as in the file. Used by the snapshotter / diff UI. */
export function allResults() {
  return state.results;
}

export function liveMeta() {
  return state._meta;
}
